export const parseKeywords = (keyword: string): string[] => {
  return keyword
    .split(',')
    .flatMap((it) => it.split('\n'))
    .map((it) => it.trim())
    .filter(Boolean);
};
